import styled from 'styled-components';

export const ButtonWrapper = styled.button`
  border: none;
  padding: 0px;
  background-color: transparent;
  cursor: pointer;
`;
